import React, {useEffect} from 'react';
import PaymentForm from './PaymentForm.js';
import './styles.css';

const AdminPaymentCards = ({catchResponse, user}) => {

  useEffect(() => {
    setTimeout(() => {
      PaymentForm(user,catchResponse);
     }, 500);
  }, []);

  return (
    <div id="payment_example_div">
      <div id="tokenize_example"></div>
      <div id="response"></div>
      <button id="tokenize_btn" className="tok_btn">
        Save card
      </button>
      <button id="retry_btn" className="tok_btn" style={{ display: 'none' }}>
        Save new card
      </button>
    </div>
  );
};
export default AdminPaymentCards;
